import React, { Component } from 'react';
import Hammer from 'hammerjs';
import './GridBox.css';
import {SanitizeClassNames} from "../../common";


let ItemIDs = 0;


// tx - Tile X value to convert to pixel values
// cx - container width in pixels
// gx - grid x tiles
const tileXToPx = (tx, cx, gx) => {
	return parseInt((cx / gx) * tx, 10);
}

// ty - Tile Y value to convert to pixel values
// cy - container height in pixels
// gy - grid y tiles
const tileYToPx = (ty, cy, gy) => {
	return parseInt((cy / gy) * ty, 10);
}


//px, py - Pixel Values to convert to tile values
// gx, gy - x/y tiles in grid
// cx, cy - container size in pixels
// intMethod - How to hand dropping decimal place
const pxToTile = (px, py, cx, cy, gx, gy, intMethod = 'floor') => {
	const tileW = cx / gx;
	const tileH = cy / gy;

	return [Math[intMethod](px / tileW), Math[intMethod](py / tileH)];
}

//tx, ty - Tile Values to convert to pixel values
// gx, gy - x/y tiles in grid
// cx, cy - container size in pixels
const tileToPx = (tx, ty, cx, cy, gx, gy) => {
	const tileW = cx / gx;
	const tileH = cy / gy;
	return [parseInt(tileW * tx, 10), parseInt(tileH * ty, 10)];
}

const tilePositionElement = (dom, grid, x, y, w, h) => {
	if(dom) {
		const bounds = grid.boundsTileToPerc([x, y, w, h]);
		const style = dom.style;
		//style.webkitTransform =
		style.transform = 'translate3D(0px, 0px, 0px)';
		style.left = (bounds[0] * 100) + '%';
		style.top = (bounds[1] * 100) + '%' ;
		style.width = (bounds[2] * 100) + '%' ;
		style.height = (bounds[3] * 100) + '%' ;
	}
}


/**
 * GridBox
 * bounds - [x,y,w,h]
 */
export default class GridBox extends Component {
	state = {
		items: {},
		layers: {
			root: {
				items: {}
			}
		}
	}

	updateRef = (ref) => {
		if(!ref) return;
		this.dom = ref;

		this.setState( {ready: true } );
	}

	componentWillUnmount() {
		//this.mc.destroy();
	}

	get grid() {
		return this.props.grid || [10,10];
	}
	boundsPxToTile = (pxBounds, intMethod = 'floor') => {
		const container = this.dom.getBoundingClientRect();
		const txy = pxToTile(pxBounds[0], pxBounds[1], container.width, container.height, this.grid[0], this.grid[1], intMethod);
		const twh = pxToTile(pxBounds[2], pxBounds[3], container.width, container.height, this.grid[0], this.grid[1], intMethod);
		return [txy[0], txy[1], twh[0], twh[1]];
	}

	boundsTileToPx = (tileBounds) => {
		const container = this.dom.getBoundingClientRect();
		const pxy = tileToPx(tileBounds[0], tileBounds[1], container.width, container.height, this.grid[0], this.grid[1]);
		const pwh = tileToPx(tileBounds[2], tileBounds[3], container.width, container.height, this.grid[0], this.grid[1]);
		return [pxy[0], pxy[1], pwh[0], pwh[1]];
	}

	boundsTileToPerc = (tileBounds) => {
		const rect = this.dom.getBoundingClientRect();
		const pxBounds = this.boundsTileToPx(tileBounds);
		const x = pxBounds[0] / rect.width;
		const y = pxBounds[1] / rect.height;
		const w = pxBounds[2] / rect.width;
		const h = pxBounds[3] / rect.height;

		return [x, y, w, h];
	}

	boundsPxToPerc(bounds) {
		const rect = this.dom.getBoundingClientRect();
		const x = bounds[0] / rect.width;
		const y = bounds[1] / rect.height;
		const w = bounds[2] / rect.width;
		const h = bounds[3] / rect.height;

		return [x, y, w, h];

	}

	//Bounds = x, y, width, height
	addItem(item, bounds = [0,0,1,1], key = ItemIDs++) {
		const items = this.state.items;
		items[key] = {item, bounds: bounds };
		this.setState( {items: items} );
		return items[key];
	}
	updateItem(itemId, bounds) {
		const items = this.state.items;
		//console.log('Update Item Bounds:', bounds)
		return this.addItem(items[itemId].item, bounds, itemId);
	}

	removeItem(itemId) {
		const items = this.state.items;
		delete items[itemId];
		this.setState( {items: items} )
	}

	clearItems() {
		this.setState( {items: {}} );
	}

	renderItems() {
		if(!this.dom) return [];
		const items = [];

		for(let layerId in this.props.items){
			const layer = this.props.items[layerId];
			items.push(<GridBoxLayer key={layerId} layerName={layerId} lines={layer.lines} items={layer.items} static={layer.static} grid={this} className={layer.className} />);
		}

		/*for(let p in this.props.items) {
			const item = this.props.items[p];
			const b = item.bounds;
			items.push((<GridBoxItem key={p} grid={this} x={b[0]} y={b[1]} w={b[2]} h={b[3]} itemId={p} onSelect={this.handleItemEvent} onDragStart={this.handleItemEvent} onDrag={this.handleItemEvent} onDragEnd={this.handleItemEvent} >{item.item}</GridBoxItem>));
		}*/
		return items;
	}

	renderGridLines() {
		if(!this.dom) return []
		const rc = this.props.lines || this.grid;
		const rows = rc[1];
		const cols = rc[0];
		const rect = this.dom.getBoundingClientRect();
		const lines = [];
		for(let r = 1; r < rows; r++){
			const y = tileYToPx(r, rect.height, rows) / rect.height;
			const style = {
				top: (y * 100) + '%'
			}

			lines.push(<div key={'row-' + r} className='grid-line row' style={style}></div>)
		}

		for(let c = 1; c < cols; c++){
			const x = tileXToPx(c, rect.width, cols) / rect.width;
			const style = {
				left: (x * 100) + '%'
			}

			lines.push(<div key={'col-' + c} className='grid-line col' style={style}></div>)
		}

		return lines;

	}

	render() {
		return (
			<div className={SanitizeClassNames(this, 'grid-box')}  ref={this.updateRef}>{this.renderItems()}</div>
		);
	}
}

export class GridBoxItem extends Component {

	state = {
		isActive: false
	}

	get w() {
		return this.props.w || 1;
	}
	get h() {
		return this.props.h || 1;
	}
	get x() {
		return this.props.x || 0;
	}
	get y() {
		return this.props.y || 0;
	}

	get boundsToPx(){
		return this.props.grid.boundsTileToPx;
	}
	get pxToBounds(){
		return this.props.grid.boundsPxToTile;
	}

	get boundsTileToPerc() {
		return this.props.grid.boundsTileToPerc
	}

	updatePos(mPos) {
		const x = mPos[0];
		const y = mPos[1];
		this.moveTo(x, y);
		return [x, y];
	}


	moveTo(x, y){
		if(this.dom) {
			const style = this.dom.style;
			// style.webkitTransform =
			if(this.state.isResize){
				const bounds = this.boundsTileToPerc([this.x, this.y, this.w, this.h]);
				style.height = 'calc(' + (bounds[3] * 100) + '% + ' + y + 'px)';
			} else{
				style.transform = 'translate3D(' + x + 'px, ' + y + 'px, 0px)';
			}

		}
	}

	matchBounds() {
		if(this.dom) {
			const bounds = this.boundsTileToPerc([this.x, this.y, this.w, this.h]);
			const style = this.dom.style;
			//style.webkitTransform =
			style.transform = 'translate3D(0px, 0px, 0px)';
			style.left = (bounds[0] * 100) + '%'  // this.x  + 'px';
			style.top = (bounds[1] * 100) + '%' ;// this.y + 'px';
			style.width = (bounds[2] * 100) + '%' ;// this.width + 'px';
			style.height = (bounds[3] * 100) + '%' ;// this.height + 'px';
		}
	}

	handleMoveEvents = (e, eventName) => {

		this.updatePos([e.deltaX, e.deltaY]);
		let bounds = [e.deltaX, e.deltaY, 0, 0];
		if(this.state.isResize){
			bounds = [0, 0, 0, e.deltaY];
		} else {
			bounds = [e.deltaX, e.deltaY, 0, 0];
		}
		const deltaBounds = this.pxToBounds(bounds, 'round');
		//const hasChanged = deltaBounds.reduce((v1, v2) => v1 + v2) !== 0;
		this.dispatchChange(eventName, [this.x + deltaBounds[0], this.y + deltaBounds[1], this.w + deltaBounds[2], this.h + deltaBounds[3]], e);
	}

	dispatchChange = (event, bounds, e) => {
		switch(event){
			case 'onDragStart':
				this.setState({isActive:true});
				break;
			case 'onDragEnd':
				this.setState({isActive:false, isResize: false});
				break;
		}

		if(this.props.onItemEvent){
			this.props.onItemEvent(this.props.itemId, bounds, event, e)
		}

		/*if( this.props[event]) {
			this.props[event](this.props.itemId, bounds, event, e)
		}

		if(this.props.externalEvents){
			const ext = this.props.externalEvents;
			if(ext[event]){
				ext[event](this.props.itemId, bounds, event, e)
			}
		}*/
	}

	handleDrag = (e) => {
		this.handleMoveEvents(e, 'onDrag');
	}

	handleDragStart = (e) => {
		this.handleMoveEvents(e, 'onDragStart');
	}

	handleDragEnd = (e) => {
		this.handleMoveEvents(e, 'onDragEnd');
	}

	handleTapEvents = (e, event) => {
		const center = e.center;
		const container = this.props.grid.dom.getBoundingClientRect();

		const bounds = this.pxToBounds([center.x - container.x, center.y - container.y, center.x, center.y]);

		console.log(`Event: %c${event}`, 'color: red');
		console.log(`\tx: ${e.center.x}, y: ${e.center.y}`);
		console.log(`\ttileX: ${bounds[0]}, tileY: ${bounds[1]}`);
		console.log(`\tContainer:`, container)

		this.dispatchChange(event, bounds, e);
	}

	handleTap = (e) => {

		this.handleTapEvents(e, 'onTap');

		//this.handleMoveEvents(e, 'onTap');
	}

	handleDoubleTap = (e) => {

		this.handleTapEvents(e, 'onDoubleTap');
		/*
		console.log('Double Tap e:', e)
		const center = e.center;
		const container = this.props.grid.dom.getBoundingClientRect();

		console.log('Double Tap Container:', container);


		const bounds = this.pxToBounds([center.x - container.x, center.y - container.y, center.x, center.y]);



		this.dispatchChange('onDoubleTap', bounds, e);*/

		//this.handleMoveEvents(e, 'onDoubleTap');
	}

	componentWillUnmount() {
		if(this.mc)this.mc.destroy();
	}

	renderResizeHandle() {
		if(this.props.allowResize){
			return <div className='resize-handle' onMouseDown={this.handleResizeStart} onMouseUp={this.handleResizeEnd}></div>
		}
	}

	handleResizeStart = (e) => {
		this.setState( { isResize: true });
	}

	handleResizeEnd = (e) => {
		this.setState ( {isResize: false });
	}



	updateRef = (ref) => {
		if(!ref) return;

		this.dom = ref;

		if(this.props.static) return;

		this.mc = new Hammer(this.dom);

		if(this.props.draggable){
			this.mc.add( new Hammer.Pan({ direction: Hammer.DIRECTION_ALL, threshold: 0 }) );
			this.mc.on("pan", this.handleDrag);
			this.mc.on('panstart', this.handleDragStart);
			this.mc.on('panend', this.handleDragEnd);
			this.mc.on('pancancel', this.handleDragEnd);
		}

		this.mc.on('tap', this.handleTap);
		this.mc.on('doubletap', this.handleDoubleTap)

		this.matchBounds();

	}

	render() {
		this.matchBounds();
		return (
			<div className={SanitizeClassNames(this, `grid-box-item ${this.state.isActive? 'dragging': ''} ${this.props.static? 'static': ''} ${this.state.isResize? 'resizing':''}`)} ref={this.updateRef} item-id={this.props.itemId} x={this.props.x} y={this.props.y} w={this.props.w} h={this.props.h} >{this.props.children}{this.renderResizeHandle()}</div>
		)
	}
}


export class GridBoxLayer extends Component{

	renderGridLines() {
		const grid = this.props.grid;
		const dom = grid.dom;

		if(!dom || !this.props.lines) return []

		const rc = this.props.lines;
		const rows = rc[1];
		const cols = rc[0];
		const rect = dom.getBoundingClientRect();
		const lines = [];
		for(let r = 1; r < rows; r++){
			const y = tileYToPx(r, rect.height, rows) / rect.height;
			const style = {
				top: (y * 100) + '%'
			}

			lines.push(<div key={'row-' + r} className='grid-line row' style={style}></div>)
		}

		for(let c = 1; c < cols; c++){
			const x = tileXToPx(c, rect.width, cols) / rect.width;
			const style = {
				left: (x * 100) + '%'
			}

			lines.push(<div key={'col-' + c} className='grid-line col' style={style}></div>)
		}

		return lines;

	}

	handleItemEvent = (itemId, bounds, eventName, touchEvent) => {
		const grid = this.props.grid;
		if(bounds[0] >= 0 && bounds[0] <= grid.grid[0] && bounds[1] >= 0 && bounds[1] <= grid.grid[1] && bounds[2] > 0 && bounds[3] > 0 || (eventName == 'onTap' || eventName == 'onDoubleTap' )) {
			if (grid.props[eventName]) {
				const item = this.props.items[itemId];
				grid.props[eventName](item, bounds, itemId, eventName, this.props.layerName, touchEvent);
			}
		}
	}

	renderItems() {
		const items = [];
		for(let p in this.props.items) {
			const item = this.props.items[p];
			const b = item.bounds;
			if(b[0] != null && b[1] != null && b[2] != null && b[3] != null){
				items.push((<GridBoxItem className={item.className} externalEvents={item.events} draggable={item.draggable} key={p} grid={this.props.grid} allowResize={item.allowResize} x={b[0]} y={b[1]} w={b[2]} h={b[3]} itemId={p} static={item.static} onItemEvent={this.handleItemEvent} >{item.item}</GridBoxItem>));
			}
		}
		return items;
	}
	render() {
		return (
			<div className={SanitizeClassNames(this, 'grid-box-layer' + (this.props.static? ' static': ''))} layer-name={this.props.layerName}>{this.renderGridLines()}{this.renderItems()}</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/components/gridbox/GridBox.jsx